<template>
  <section class="customer-memberships" aria-label="Mitgliedschaften und Pakete">
    <div v-if="loading" class="customer-memberships__loading" role="status"><v-progress-circular indeterminate color="primary" size="26" /> <span>Mitgliedschaften werden geladen …</span></div>
    <v-alert v-if="error" type="warning" text>{{ error }}<v-btn text small :loading="loading" @click="$emit('retry')">Erneut laden</v-btn></v-alert>
    <template v-if="!loading && !error">
      <CustomerHubMembershipCard v-for="(membership, index) in currentMemberships" :key="membership.id + '-' + index" :membership="membership" :today="today" :upgrades="membership === upgradeMembership ? upgradeOptions : []" @upgrade="$emit('upgrade', $event)">
        <template #actions><slot v-if="index === 0" name="actions" /></template>
      </CustomerHubMembershipCard>
      <p v-if="!currentMemberships.length" class="customer-memberships__empty">Es ist keine aktuelle oder kommende Mitgliedschaft hinterlegt.</p>
      <p v-if="upgradesLoading" class="customer-memberships__upgrade-note" role="status">Verfügbare Pakete werden geladen …</p>
      <div v-else-if="upgradesError" class="customer-memberships__upgrade-note" role="status">{{ upgradesError }} <button type="button" @click="$emit('retry-upgrades')">Erneut laden</button></div>
      <section v-else-if="upgradeOptions.length && !upgradeMembership" class="customer-memberships__catalog" aria-label="Verfügbare Pakete">
        <h3>Weitere Pakete</h3><p>Für {{ upgradeData.roodyMembershipName || upgradeData.membershipName || 'dein Abo' }}<template v-if="upgradeData.studioPopulated && upgradeData.studioPopulated.name"> · {{ upgradeData.studioPopulated.name }}</template></p>
        <div class="customer-memberships__grid"><CustomerHubUpgradeTile v-for="pack in upgradeOptions" :key="pack.key" :pack="pack" @select="$emit('upgrade', $event)" /></div>
      </section>
      <CustomerHubHistory :items="pastMemberships" title="Vergangene Abos" selection-label="Abo nach Laufzeit auswählen">
        <template #default="{ item }"><CustomerHubMembershipCard :membership="item" :today="today" /></template>
      </CustomerHubHistory>
    </template>
    <v-card v-if="nutrition" dark flat class="customer-memberships__nutrition pa-4 my-4">
      <h3>Ernährungsberatung</h3><p>{{ date(nutrition.startDate) }} – {{ date(nutrition.endDate) }}</p>
      <v-btn outlined rounded dark small @click="$emit('nutrition')">Vertragsbedingungen ansehen</v-btn>
    </v-card>

  </section>
</template>

<script>
import CustomerHubMembershipCard from "./CustomerHubMembershipCard.vue"
import CustomerHubHistory from "./CustomerHubHistory.vue"
import CustomerHubUpgradeTile from "./CustomerHubUpgradeTile.vue"
import { customerHubContractId } from "@/services/customerHubUpgrades"
import { customerHubMemberships } from "@/services/customerHubMemberships"
export default {
  name: "CustomerHubMemberships",
  components: { CustomerHubMembershipCard, CustomerHubHistory, CustomerHubUpgradeTile },
  props: {
    response: { type: Object, default: null }, studios: { type: Array, default: () => [] },
    loading: Boolean, error: { type: String, default: "" },
    nutrition: { type: Object, default: null },
    upgradeData: { type: Object, default: null }, upgradeOptions: { type: Array, default: () => [] },
    upgradesLoading: Boolean, upgradesError: { type: String, default: "" },
  },
  computed: {
    today() { return this.$moment().format("YYYY-MM-DD") },
    memberships() { return customerHubMemberships(this.response, { today: this.today, studios: this.studios }) },
    currentMemberships() { return this.memberships.filter(item => item.group !== "past") },
    upgradeMembership() { const id = customerHubContractId(this.upgradeData?.contractID); return id ? this.currentMemberships.find(item => customerHubContractId(item.id) === id) : null },
    pastMemberships() { return this.memberships.filter(item => item.group === "past") },
  },
  methods: { date(value) { return value ? this.$moment(value).format("DD.MM.YYYY") : "nicht angegeben" } },
}
</script>

<style scoped>
.customer-memberships__loading { display: flex; gap: 12px; align-items: center; justify-content: center; padding: 28px 12px; color: #bcbcbc; font-size: 13px; }
.customer-memberships__empty { padding: 18px 0; color: #c2c2c2; font-size: 14px; }
.customer-memberships__nutrition { background: #242424; border: 1px solid #ffffff16; border-radius: 18px; }.customer-memberships__nutrition h3 { font-size: 17px; }.customer-memberships__nutrition p { font-size: 13px; color: #b9b9b9; margin-top: 8px; }
.customer-memberships__upgrade-note { color: #b0b0b0; font-size: 12px; line-height: 1.6; margin: 12px 0; }
.customer-memberships__upgrade-note button { text-decoration: underline; color: #e0e0e0; padding: 6px; }
.customer-memberships__catalog { margin: 18px 0; }.customer-memberships__catalog h3 { font-size: 15px; }.customer-memberships__catalog p { color: #b0b0b0; font-size: 12px; margin: 6px 0 12px; }
.customer-memberships__grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
@media (max-width: 350px) { .customer-memberships__grid { grid-template-columns: minmax(0, 1fr); } }
</style>
